import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Preheader from "../KalHome/Preheader";
import Header from "../KalHome/Header";
import Footer from "../Homecomponents/Footer";
import "./SeeAllSubcategory.css";
import { cartUtils, wishlistUtils } from "../utils/userCartWishlistUtils";
import SocialLinks from "../Homecomponents/Sociallinks";
import Endfooter from "../Homecomponents/Endfooter";
import ProgressLoader from "../Loader/ProgressLoader";
import Superheader from "../KalHome/Superheader";
import { FaArrowLeft, FaHeart, FaRegHeart } from "react-icons/fa";

const SeeAllSubcategory = () => {
  const { subCategoryId } = useParams();
  const [isSticky, setIsSticky] = useState(false);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("relevance");
  const [wishlistStatus, setWishlistStatus] = useState({});
  const [showLoginAlert, setShowLoginAlert] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Get subcategory info from navigation state
  const { subCategoryName, categoryId } = location.state || {};

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Initialize wishlist status
  useEffect(() => {
    if (products.length > 0) {
      const initialWishlistStatus = {};

      products.forEach((product) => {
        initialWishlistStatus[product.id] = wishlistUtils.isInWishlist(
          product.id
        );
      });

      setWishlistStatus(initialWishlistStatus);
    }
  }, [products]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList?subCategoryId=${subCategoryId}`
      );
      setProducts(response.data);
      setFilteredProducts(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      await fetchData();
    };

    if (isMounted) {
      loadData();
    }

    return () => {
      isMounted = false;
    };
  }, [location.pathname]);

  // Filter and sort products
  useEffect(() => {
    let updatedProducts = [...products];

    // Filter by search query
    if (searchQuery) {
      updatedProducts = updatedProducts.filter(
        (product) =>
          product.brandName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          product.productName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Sort products
    if (sortOption === "lowToHigh") {
      updatedProducts.sort((a, b) => a.sellingPrice - b.sellingPrice);
    } else if (sortOption === "highToLow") {
      updatedProducts.sort((a, b) => b.sellingPrice - a.sellingPrice);
    }

    setFilteredProducts(updatedProducts);
  }, [searchQuery, sortOption, products]);

  // Wishlist handlers
  const handleWishlistToggle = async (productId) => {
    if (wishlistStatus[productId]) {
      const success = await wishlistUtils.removeFromWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: false,
        }));
      }
    } else {
      const success = await wishlistUtils.addToWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: true,
        }));
      } else {
        setShowLoginAlert(true);
      }
    }
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, {
      state: { product, productCategory: categoryId },
    });
  };

  if (loading) {
    return (
      <>
        {/* <Preheader /> */}
        <Superheader />
        <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
          <Header />
        </div>
        <div className="seeall-loading-container">
          <ProgressLoader />
        </div>
      </>
    );
  }

  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <div className="seeall-main-container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-center align-items-center gap-3">
            <div className="seeall-backarrow">
              <FaArrowLeft size={25} color="#920504" onClick={()=> navigate(-1)}/>
            </div>
            <div>
              <h2 className="seeall-page-title m-0" style={{ color: "#920504" }}>
            {/* <i className="fa fa-shopping-bag me-2"></i> */}
            {subCategoryName || "Products"}
            </h2>
            </div>
            
          </div>
          <div className="seeall-sort-container">
            <select
              className="form-select"
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
            >
              <option value="relevance">Relevance</option>
              <option value="lowToHigh">Low to High</option>
              <option value="highToLow">High to Low</option>
            </select>
          </div>
        </div>

        <div className="seeall-products-grid">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div key={product.id} className="seeall-product-card">
                <div
                  className="seeall-product-image-container"
                  onClick={() => handleProductClick(product)}
                >
                  <img
                    src={
                      product.productImage
                        ? `https://api.dremerz.net/uploads/${product.productImage}`
                        : "/default-product.jpg"
                    }
                    alt={product.brandName}
                    className="seeall-product-image"
                  />
                  {product.tags && (
                    <span className="seeall-product-tag">{product.tags}</span>
                  )}
                </div>
                <div className="seeall-product-info">
                  <h3 onClick={() => handleProductClick(product)}>
                    {product.brandName}
                  </h3>
                  <p className="seeall-product-name m-0">
                    {product.productName}
                  </p>
                  <div
                    className="seeall-product-price"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span
                      className="seeall-current-price"
                      style={{ fontSize: "18px" }}
                    >
                      ₹{product.sellingPrice}
                    </span>

                    {product.originalPrice && (
                      <>
                        <span
                          className="seeall-original-price"
                          style={{
                            fontSize: "14px",
                            textDecoration: "line-through",
                          }}
                        >
                          ₹{product.originalPrice}
                        </span>
                        <span
                          className="seeall-offer"
                          style={{
                            fontSize: "14px",
                            whiteSpace: "nowrap", // keeps "(50% OFF)" in one line
                          }}
                        >
                          (
                          {Math.round(
                            ((product.originalPrice - product.sellingPrice) /
                              product.originalPrice) *
                              100
                          )}
                          % OFF)
                        </span>
                      </>
                    )}
                  </div>

                  <div className="seeall-product-actions">
                    <button
                      className={`seeall-action-btn seeall-wishlist-btn ${
                        wishlistStatus[product.id] ? "seeall-in-wishlist" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleWishlistToggle(product.id);
                      }}
                    >
                      {wishlistStatus[product.id] ? (
                        <FaHeart />
                      ) : (
                        <FaRegHeart />
                      )}

                      {wishlistStatus[product.id] ? " Wishlisted" : " Wishlist"}
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="seeall-no-products">
              <p>No products found matching your search.</p>
            </div>
          )}
        </div>

        {showLoginAlert && (
          <div className="seeall-modal-overlay">
            <div className="seeall-modal-content">
              <h3>Login Required</h3>
              <p>Please login to add items to your wishlist.</p>
              <div className="seeall-modal-actions">
                <button
                  className="seeall-btn-cancel"
                  onClick={() => setShowLoginAlert(false)}
                >
                  Cancel
                </button>
                <button
                  className="seeall-btn-login"
                  onClick={() => navigate("/login")}
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
      <SocialLinks />
      <Endfooter />
    </>
  );
};

export default SeeAllSubcategory;
